import { EnvValidationError } from '../errors/EnvValidationError';
import { setApplicationMode } from './isApplicationMode';
import { parseValue } from './parseValue';
export function createConfig(schema, rawEnv, options) {
    setApplicationMode(options.applicationMode);
    const result = {};
    const errors = [];
    for (const [semanticKey, fieldDef] of Object.entries(schema)) {
        const rawValue = rawEnv[fieldDef.envKey];
        if (!rawValue) {
            if (fieldDef.required) {
                options.onMissingVar?.(fieldDef.envKey);
                errors.push(`Missing required environment variable: ${fieldDef.envKey}`);
            }
            else {
                result[semanticKey] = 'default' in fieldDef && fieldDef.default !== undefined ? fieldDef.default : undefined;
            }
            continue;
        }
        try {
            result[semanticKey] = parseValue(rawValue, fieldDef.type, fieldDef.envKey);
        }
        catch (error) {
            const errorMessage = error instanceof Error ? error.message : `Invalid value for ${fieldDef.envKey}`;
            options.onInvalidType?.(fieldDef.envKey, fieldDef.type, rawValue);
            errors.push(errorMessage);
        }
    }
    if (errors.length > 0) {
        throw new EnvValidationError(errors);
    }
    return Object.freeze(result);
}
